import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientBulkCancelContent のスタイル
 */
export const hotlineClientBulkCancelContentStyle = tv({
    slots: {
        base: [
            'flex flex-col md:flex-row lg:flex-col xl:flex-row justify-center md:justify-between lg:justify-center xl:justify-between items-center gap-16',
            'p-16',
            'bg-white',
            'shadow-md',
            'rounded-md',
        ],
        text: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        textContentWrap: ['flex items-center gap-4'],
    },
});
